import React from 'react'
import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'danger-outline' | 'text'

interface SharedButtonProps extends Omit<MuiButtonProps, 'variant' | 'color'> {
  label: string
  btnVariant?: ButtonVariant
  loading?: boolean
  loadingText?: string
  to?: string
}

const variantMap: Record<
  ButtonVariant,
  { variant: MuiButtonProps['variant']; color?: MuiButtonProps['color']; sx: object }
> = {
  primary: {
    variant: 'contained',
    sx: {},
  },
  secondary: {
    variant: 'outlined',
    sx: {},
  },
  danger: {
    variant: 'contained',
    color: 'error',
    sx: {
      bgcolor: '#ef4444',
      '&:hover': { bgcolor: '#dc2626' },
    },
  },
  'danger-outline': {
    variant: 'outlined',
    color: 'error',
    sx: {
      '&.Mui-disabled': {
        borderColor: 'rgba(239, 68, 68, 0.5)',
        color: 'rgba(239, 68, 68, 0.5)',
      },
    },
  },
  text: {
    variant: 'text',
    sx: {},
  },
}

const SharedButton = ({
  label,
  btnVariant = 'primary',
  loading = false,
  loadingText,
  to,
  disabled,
  startIcon,
  sx,
  ...rest
}: SharedButtonProps) => {
  const config = variantMap[btnVariant]

  const resolvedIcon = loading ? <CircularProgress size={16} color="inherit" /> : startIcon

  const linkProps = to ? { component: RouterLink as any, to } : {}

  return (
    <MuiButton
      variant={config.variant}
      color={config.color}
      disabled={disabled || loading}
      startIcon={resolvedIcon}
      sx={{
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '13px',
        py: 1,
        px: 2.5,
        ...config.sx,
        ...sx,
      }}
      {...linkProps}
      {...rest}
    >
      {loading && loadingText ? loadingText : label}
    </MuiButton>
  )
}

export default SharedButton
